'use client';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import CustomLink from '@/components/ui/common/custom-link';
import { useLocale } from '@/components/providers/context/locale-context';
import { JContainer } from '@/components/ui/layout';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

function JoinUs() {
    const { t } = useTranslation('join-us');
    const locale = useLocale();
    return (
        <div className="flex w-full flex-col items-center bg-white">
            <JContainer
                size="lg"
                padding="md"
                className="flex flex-col items-center py-[60px] sm:py-[100px]"
            >
                <div
                    className={clsx('', {
                        'j-h3 block': locale === 'en',
                        hidden: locale === 'zh',
                    })}
                >
                    You know, whether we accept it or not, AI is changing the
                    world, and no one can remain unaffected. Do you choose to
                    sit back, mock, and watch, or will you join us in leveraging
                    technology to push this world even further?
                </div>
                <div
                    className={clsx('', {
                        hidden: locale === 'en',
                        'j-h3 block': locale === 'zh',
                    })}
                >
                    无论我们是否接受，AI正在切切实实地改变这个世界，没人能够置身事外。你是选择观望不前、袖手旁观或者冷嘲热讽，还是愿意加入我们，一起用技术让我们的世界走的更远?
                </div>

                {/* <div
                    className={clsx('flex flex-col', {
                        hidden: locale === 'en',
                        'j-h3 block': locale === 'zh',
                    })}
                >
                    <div>无论我们是否接受，</div>
                    <div>AI正在切切实实地改变这个世界，</div>
                    <div
                        style={{
                            WebkitTextFillColor: 'transparent',
                        }}
                        className="bg-[linear-gradient(90deg,_#7857ff_8.37%,_#e7a9fd_56.02%)] bg-clip-text"
                    >
                        没人能够置身事外。
                    </div>
                    <br />

                    <div>你是选择观望不前、袖手旁观或者冷嘲热讽，</div>
                    <div>
                        还是愿意
                        <span
                            style={{
                                WebkitTextFillColor: 'transparent',
                            }}
                            className="bg-[linear-gradient(90deg,_#7857ff_8.37%,_#e7a9fd_56.02%)] bg-clip-text"
                        >
                            加入我们，
                        </span>
                    </div>
                    <div>一起用技术让我们的世界走的更远?</div>
                </div> */}

                <div
                    className={clsx(
                        'mt-[40px] flex flex-col gap-[40px] sm:mt-[120px] sm:flex-row sm:gap-[80px]',
                    )}
                >
                    <div className="flex aspect-video w-full items-center justify-center overflow-hidden sm:basis-1/2">
                        <img
                            className="h-full w-full object-cover object-center"
                            src={getStaticAssetUrl(
                                '/about/joinai-recruitment-concept-illustration.webp',
                            )}
                            alt={t('imageDesc')}
                        />
                    </div>

                    <div className="flex h-full w-full flex-col items-center justify-center pl-0 pt-0 sm:basis-1/2">
                        <h2 className={clsx('j-h3')}>{t('title')}</h2>
                        <div className={clsx('j-h5 mt-[16px]')}>
                            {t('content.part1')}
                            <CustomLink
                                href={
                                    locale === 'en'
                                        ? 'mailto:jobs@join-intelligence.com?subject=Join%20Us&body=Dear%20JoinAI%20Hiring%20Team%2C%0A%0AI%20am%20writing%20to%20express%20my%20interest%20in%20the%20%5BPosition%20Name%5D%20advertised%20on%20%5Bwhere%20you%20found%20the%20job%20posting%5D.%20I%20am%20particularly%20drawn%20to%20this%20opportunity%20at%20%5BYour%20Company%20Name%5D%20because%20%5Bmention%20what%20attracts%20you%20to%20the%20company%20or%20role%5D.%0A%0AAttached%20are%20my%20resume%20and%20cover%20letter%20for%20your%20review.%20%0A%0AThank%20you%20for%20considering%20my%20application.%20I%20am%20looking%20forward%20to%20the%20opportunity%20to%20discuss%20how%20my%20skills%20and%20experiences%20align%20with%20the%20needs%20of%20your%20team.%0A%0ABest%20regards%2C%0A%5BYour%20Name%5D%0A%5BYour%20Contact%20Information%5D'
                                        : 'mailto:jobs@join-intelligence.com?subject=%E5%8A%A0%E5%85%A5%E6%88%91%E4%BB%AC&body=%E5%B0%8A%E6%95%AC%E7%9A%84%20%E5%8D%93%E5%8D%B0%E6%99%BA%E8%83%BD%20%E6%8B%9B%E8%81%98%E5%9B%A2%E9%98%9F%EF%BC%8C%0A%0A%E6%88%91%E5%86%99%E4%BF%A1%E6%98%AF%E4%B8%BA%E4%BA%86%E8%A1%A8%E8%BE%BE%E6%88%91%E5%AF%B9%E8%B4%B5%E5%85%AC%E5%8F%B8%5B%E5%9C%A8%E5%93%AA%E9%87%8C%E7%9C%8B%E5%88%B0%E7%9A%84%E8%81%8C%E4%BD%8D%E5%B9%BF%E5%91%8A%5D%E5%85%AC%E5%B8%83%E7%9A%84%5B%E8%81%8C%E4%BD%8D%E5%90%8D%E7%A7%B0%5D%E8%81%8C%E4%BD%8D%E7%9A%84%E5%85%B4%E8%B6%A3%E3%80%82%E6%88%91%E7%89%B9%E5%88%AB%E8%A2%AB%5B%E6%8F%90%E5%8F%8A%E5%90%B8%E5%BC%95%E6%82%A8%E5%88%B0%E8%AF%A5%E5%85%AC%E5%8F%B8%E6%88%96%E8%81%8C%E4%BD%8D%E7%9A%84%E5%8E%9F%E5%9B%A0%5D%E6%89%80%E5%90%B8%E5%BC%95%E3%80%82%0A%0A%E9%9A%8F%E4%BF%A1%E9%99%84%E4%B8%8A%E6%88%91%E7%9A%84%E7%AE%80%E5%8E%86%E5%92%8C%E6%B1%82%E8%81%8C%E4%BF%A1%E4%BE%9B%E6%82%A8%E8%AF%84%E5%AE%A1%E3%80%82%0A%0A%E6%84%9F%E8%B0%A2%E6%82%A8%E8%80%83%E8%99%91%E6%88%91%E7%9A%84%E7%94%B3%E8%AF%B7%E3%80%82%E6%9C%9F%E5%BE%85%E6%9C%89%E6%9C%BA%E4%BC%9A%E8%BF%9B%E4%B8%80%E6%AD%A5%E8%AE%A8%E8%AE%BA%E6%88%91%E5%A6%82%E4%BD%95%E8%83%BD%E5%A4%9F%E7%AC%A6%E5%90%88%E8%B4%B5%E5%9B%A2%E9%98%9F%E7%9A%84%E9%9C%80%E6%B1%82%E3%80%82%0A%0A%E6%AD%A4%E8%87%B4%E6%95%AC%E7%A4%BC%EF%BC%8C%0A%5B%E6%82%A8%E7%9A%84%E5%A7%93%E5%90%8D%5D%0A%5B%E6%82%A8%E7%9A%84%E8%81%94%E7%B3%BB%E4%BF%A1%E6%81%AF%5D'
                                }
                                iconSize={24}
                            >
                                jobs@join-intelligence.com
                            </CustomLink>
                            {t('content.part2')}
                        </div>
                    </div>
                </div>
            </JContainer>
        </div>
    );
}
export default JoinUs;
